import { componentProps } from "../../../interfaces/ActionStartResponse";
import { toDateTimeLocalValue } from "../../../Logic/Mis/misDate";
import DateTime from "../../Generic/Form/DateTime";

/** MIS TextInput whose label contains the word "date". Stores YYYY-MM-DDTHH:mm. */
function MisDateTimeInput(props: componentProps) {
    return (
        <DateTime
            id={"mis-date-" + props.MisField.id}
            label={props.MisField.label}
            value={toDateTimeLocalValue(props.MisEntry.value) ?? ""}
            onChange={value => props.returnFunc({ fieldID: props.MisEntry.fieldID, value })}
            firstCol={props.firstCol}
        />
    );
}
export default MisDateTimeInput;
